import React from 'react';
import { Tag } from 'antd';
import { GeiInventoryVersion } from 'src/geiVersion/types';
import { formatVersionLabel, formatVersionStateBadge } from 'src/geiVersion/display';

interface OperationalVersionBannerProps {
    inventoryYear?: number | string | null;
    version: GeiInventoryVersion | null;
    explicit: boolean;
}

const OperationalVersionBanner: React.FC<OperationalVersionBannerProps> = ({ inventoryYear, version, explicit }) => {
    if (!version) return null;
    const closed = version.state === 'CLOSED';
    return (
        <div style={{ marginBottom: 12, display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
            <span>
                {inventoryYear ? `Inventario GEI ${inventoryYear}` : 'Inventario GEI'}
            </span>
            <span>{formatVersionLabel(version.versionNumber, version.label)}</span>
            <Tag color={closed ? 'default' : 'green'}>{formatVersionStateBadge(version.state)}</Tag>
            {explicit ? <Tag>Vista histórica</Tag> : <Tag color="blue">Actual</Tag>}
            {closed ? <span>Los datos de esta versión histórica no se pueden modificar.</span> : null}
        </div>
    );
};

export default OperationalVersionBanner;
